<template>
  <div class="containerDetail table-responsive col-12">
    <li
      style="
        display: block;
        color: #000000;
        font-family: dfyuanstd-w5, dfyuanstd-w3;
        font-size: 1rem;
      "
    >
      出貨明細
    </li>
    <b-table
      :items="containerDetailItem"
      :fields="containerDetailFields"
      class="text-center containerDetail-table-detail"
    >
      <template #cell(product_name)="data">
        <div>{{ data.value }}</div>
      </template>
      <template #cell(re_check)="data">
        <div v-if="data.value === true">&#10004;</div>
        <div v-else-if="containerDetailItem.length == data.index + 1"></div>
        <div v-else>-</div>
      </template>
      <template #cell(box_qty)="data">
        {{ data.value.toLocaleString("en-US") }}
      </template>
      <template #cell(pallet_weight)="data">
        {{ data.value.toLocaleString("en-US") }}
      </template>
      <template #cell(detail)="data">
        <template v-if="selectPage == 'machstatus'">
          <router-link :to="'workorderhistory'">
            <button
              type="button"
              class="btn"
              style="
                width: 53px;
                height: 22px;
                line-height: 22px;
                padding: 0px;
                background-color: #4b8c80;
                color: #ffffff;
                border: 0px;
              "
              @click="queryWorkorderhistory(data.item.runcard)"
            >
              明細
            </button>
          </router-link>
        </template>
        <template v-else-if="selectPage == 'workorderhistory'">
          <button
            type="button"
            class="btn"
            style="
              width: 53px;
              height: 22px;
              line-height: 22px;
              padding: 0px;
              background-color: #4b8c80;
              color: #ffffff;
              border: 0px;
            "
            @click="queryWorkorderhistory(data.value)"
          >
            明細
          </button>
        </template>
      </template>
    </b-table>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "containerDetail",
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      selectPage: "getlogin/get_selectPage",
      containerDetailFields: "containerDetail/get_containerDetailFields",
      containerDetailItem: "containerDetail/get_containerDetailItem",
    }),
  },
  methods: {
    ...mapActions({
      set_containerDetailQuery: "containerDetail/set_containerDetailQuery",
    }),
    queryWorkorderhistory(pkg_wko_code) {
      let vm = this;
      vm.set_containerDetailQuery({ active: true, pkg_wko_code: pkg_wko_code });
    },
  },
};
</script>

<style lang="scss">
.containerDetail-table-detail thead th {
  white-space: nowrap;
  border-top: 1px solid;
}
.containerDetail-table-detail th,
.containerDetail-table-detail td {
  font-size: 1rem;
  min-width: 65px;
  padding: 0.1rem 0.4rem;
  border-color: #999999 !important;
  border-bottom: 1px solid #999999 !important;
  border-right: 1px solid;
  font-weight: normal;
  background-color: #ffffff;
  vertical-align: middle !important;
}

.containerDetail-table-detail th:first-child,
.containerDetail-table-detail td:first-child {
  border-left: 1px solid;
}

.containerDetail-table-detail td:nth-child(4) {
  max-width: 600px;
}

.containerDetail-table-detail {
  margin-bottom: 0px;
}
.containerDetail-table-detail thead th {
  color: #000000 !important;
  background-color: #cccccc !important;
}

.containerDetail-table-detail tr:last-child td:nth-child(1) {
  background-color: transparent;
  border-color: transparent !important;
}
.containerDetail-table-detail tr:last-child td:nth-child(2) {
  background-color: transparent;
  border-color: transparent !important;
}
.containerDetail-table-detail tr:last-child td:nth-child(3) {
  background-color: transparent;
  border-color: transparent !important;
}
.containerDetail-table-detail tr:last-child td:nth-child(4) {
  background-color: transparent;
  border-color: transparent !important;
}
.containerDetail-table-detail tr:last-child td:nth-child(5) {
  border-bottom: 2px #c10000 solid !important;
  border-top: 2px #c10000 solid !important;
  border-left: 2px #c10000 solid !important;
}
.containerDetail-table-detail tr:last-child td:nth-child(6) {
  border-bottom: 2px #c10000 solid !important;
  border-top: 2px #c10000 solid !important;
}
.containerDetail-table-detail tr:last-child td:nth-child(7) {
  border-bottom: 2px #c10000 solid !important;
  border-top: 2px #c10000 solid !important;
  border-right: 2px #c10000 solid !important;
}
.containerDetail-table-detail tr:last-child td:nth-child(8) {
  background-color: transparent;
  color: transparent !important;
  border-color: transparent !important;
}
.containerDetail-table-detail tr:last-child td:nth-child(9) {
  background-color: transparent;
  color: transparent !important;
  border-color: transparent !important;
}
.containerDetail-table-detail tr:last-child td:nth-child(9) button {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/containerDetail.vue